// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"549":"c298f6ec","728":"2820efa8","881":"ae03117c","928":"8df80f6c"}[chunkId] + ".chunk.css";
};